import { takeEvery } from 'redux-saga/effects';
import { apiRequest } from './index';
import api from 'utils/api';
import * as logsActions from 'actions/AppLogs';

const getAppLogs = apiRequest.bind(null, logsActions.getAppLogs, api.getAppLogs);

export function* watchGetAppLogsRequest() {
  yield takeEvery(logsActions.GET_APP_LOGS.REQUEST, getAppLogs);
}
